(() => {
  const locale = document.documentElement.lang || 'en';
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const requests = new Map();
  const cards = new Map();
  const key = (item) => `${item.handle}:${item.variantId || ''}`;

  const hydrateItem = async (item) => {
    if (!item?.handle || !/^[\p{L}\p{N}_-]+$/u.test(item.handle)) return null;

    try {
      const requestKey = key(item);
      if (!requests.has(requestKey)) {
        const url = new URL(`${root}products/${encodeURIComponent(item.handle)}`, window.location.origin);
        url.searchParams.set('section_id', 'recent-product-card');
        if (/^\d+$/.test(String(item.variantId || ''))) url.searchParams.set('variant', item.variantId);
        requests.set(requestKey, fetch(url, { credentials: 'same-origin', cache: 'no-store' }).then(async (response) => {
          if (!response.ok) throw new Error('Product unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const card = doc.querySelector('[data-recent-product-source] [data-product-card-root]');
          if (!card || card.dataset.discountEngineProductHandle !== item.handle) throw new Error('Invalid recent product card');
          return card;
        }));
      }
      const card = await requests.get(requestKey);
      const title = card.querySelector('[data-product-card-title]')?.textContent.trim();
      const identity = card.querySelector('[data-product-card-identity]');
      if (!title || !identity) return null;
      const images = [...card.querySelectorAll('[data-product-card-image] img')].map((image) => image.getAttribute('src')).filter(Boolean);
      const current = {
        ...item,
        productId: card.dataset.discountEngineProductId,
        variantId: card.dataset.discountEngineVariantId,
        title,
        brand: card.querySelector('[data-product-card-brand]')?.textContent.trim() || '',
        url: identity.getAttribute('href'),
        volume: card.querySelector('.le-product-card__variant')?.textContent.trim() || '',
        price: card.querySelector('[data-discount-engine-price] .price')?.textContent.trim() || '',
        compareAtPrice: card.querySelector('.price--compare')?.textContent.trim() || null,
        image: images[0] || item.image,
        images,
        available: !card.classList.contains('le-product-card--sold-out'),
        memoryHydrated: true,
        memoryLocale: locale,
      };
      // Keep native HTML only in this page's memory. Persisted snapshots remain
      // structured data; future visits fetch current labels, prices and swatches.
      cards.set(key(current), card.outerHTML);
      return current;
    } catch (_error) {
      // Preserve the established same-language fallback on transient failure.
      return item.memoryLocale === locale ? item : null;
    }
  };

  window.LetoileRecentProducts = {
    hydrate: async (items) => {
      const source = items.slice(0, 12), hydrated = new Array(source.length);
      let next = 0;
      const work = async () => {
        while (next < source.length) {
          const index = next++;
          hydrated[index] = await hydrateItem(source[index]);
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, source.length) }, work));
      return hydrated.filter(Boolean);
    },
    card: (item) => item.memoryLocale === locale ? cards.get(key(item)) : null,
  };
})();
